/* Small behaviour refinements: preserve Dawn state interfaces and customer data. */
(() => {
  if (window.azelkaBrandSystemLoaded) return;
  window.azelkaBrandSystemLoaded = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  function initSlides(root) {
    root.querySelectorAll('slideshow-component').forEach((slider) => {
      if (slider.dataset.azMotionReady || !slider.querySelector('.slideshow.banner')) return;
      if (typeof slider.play !== 'function' || !slider.sliderAutoplayButton) return;
      slider.dataset.azMotionReady = 'true';
      let inView = true;
      let userPaused = false;
      const originalPlay = slider.play.bind(slider);
      const originalPause = slider.pause.bind(slider);
      slider.play = () => {
        if (reduced.matches || document.hidden || !inView || userPaused || slider.autoplayButtonIsSetToPlay === false) {
          originalPause(); return;
        }
        originalPlay();
      };
      // The original button handler runs first; its current state records explicit user intent.
      slider.sliderAutoplayButton.addEventListener('click', () => {
        userPaused = !slider.autoplayButtonIsSetToPlay;
        if (!userPaused && !reduced.matches) slider.play();
      });
      const sync = () => {
        if (!slider.isConnected) return;
        slider.sliderAutoplayButton.disabled = reduced.matches;
        if (reduced.matches) {
          originalPause(); slider.togglePlayButtonState(true);
          slider.sliderAutoplayButton.setAttribute('aria-label', 'Automatic playback is off with reduced motion');
        } else if (userPaused) {
          originalPause(); slider.togglePlayButtonState(true);
        } else {
          slider.togglePlayButtonState(false); slider.play();
        }
      };
      const observer = new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
        inView ? sync() : originalPause();
      }, { threshold: .1 });
      observer.observe(slider);
      document.addEventListener('visibilitychange', sync);
      reduced.addEventListener('change', sync);
      sync();
    });
  }

  function cleanReadingPage(root) {
    root.querySelectorAll('.az-reading-page,.shopify-policy__container').forEach((container) => {
      if (container.dataset.azReadingReady) return;
      container.dataset.azReadingReady = 'true';
      const title = container.querySelector('h1');
      const firstHeading = container.querySelector('.rte h2,.shopify-policy__body h2');
      const normalise = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, '');
      if (title && firstHeading && normalise(title.textContent) === normalise(firstHeading.textContent)) firstHeading.hidden = true;
    });
  }

  function initDiscountModal() {
    const modal = document.getElementById('nova-discount-modal');
    if (!modal || modal.dataset.azFocusReady) return;
    modal.dataset.azFocusReady = 'true';
    const restored = new Map();
    const sync = () => {
      const active = modal.classList.contains('is-open');
      if (active) {
        Array.from(document.body.children).forEach((child) => {
          if (child === modal || child.contains(modal) || /^(SCRIPT|STYLE|LINK)$/.test(child.tagName)) return;
          if (!restored.has(child)) restored.set(child, child.inert);
          child.inert = true;
        });
      } else {
        restored.forEach((value, child) => { child.inert = value; }); restored.clear();
      }
    };
    new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function showSafeContent(root) {
    const elements = root.querySelectorAll('.scroll-trigger');
    if (reduced.matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.classList.remove('scroll-trigger--offscreen');
        element.classList.add('scroll-trigger--cancel');
      });
    }
  }
  function readingChat() {
    const container = document.querySelector('.az-reading-page,.shopify-policy__container');
    if (!container || container.dataset.azChatPrepared) return;
    container.dataset.azChatPrepared = 'true';
    const help = document.createElement('div'); help.className = 'az-reading-help';
    const email = document.createElement('a'); email.href = 'mailto:support@azelka.com'; email.textContent = 'Email our team';
    const chat = document.createElement('button'); chat.type = 'button'; chat.textContent = 'Chat with us'; chat.hidden = true;
    help.append(email, chat); container.append(help);
    let attempts = 0;
    function bind() {
      if (!container.isConnected) return;
      const button = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part~="activator"]');
      if (button) {
        chat.hidden = false; chat.addEventListener('click', () => button.click());
        document.body.classList.add('az-reading-chat-ready'); return;
      }
      if (++attempts < 80) setTimeout(bind, 250);
    }
    bind();
  }
  function initialise(root) { initSlides(root); cleanReadingPage(root); initDiscountModal(); showSafeContent(root); readingChat(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  else initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  reduced.addEventListener('change', () => showSafeContent(document));
})();
